import StructuredListItem from './StructuredListItem.jsx';

export default function StructuredListBlock({ block }) {
  const title = typeof block?.title === 'string' ? block.title.trim() : '';
  const items = Array.isArray(block?.items) ? block.items : [];
  const options = block?.options && typeof block.options === 'object' ? block.options : {};

  if (items.length === 0) {
    return null;
  }

  const variant = typeof options.variant === 'string' ? options.variant.trim() : 'default';

  return (
    <section className={`savora-structured-list savora-structured-list--${variant}`}>
      {title ? <h2 className="savora-structured-list__title">{title}</h2> : null}

      <div className="savora-structured-list__items">
        {items.map((item, index) => (
          <StructuredListItem key={item?.id || index} item={item} options={options} />
        ))}
      </div>
    </section>
  );
}
